import {createContext, useContext} from 'react'

/**
 * Marks a subtree as "rendered inside a route-modal".
 *
 * Used by /map's detail-page modals (background-location pattern):
 * clicking a card's CTA opens e.g. /spaces/:id as a modal over the
 * still-mounted MapPage. The detail page itself is unchanged — but its
 * Navbar and Footer would clash with the modal chrome and cover the
 * close button. Instead of refactoring every detail page, those two
 * components opt into self-hiding when this context is true.
 *
 * Default false so non-modal usage is untouched.
 */
const ModalContext = createContext(false)

export const useInsideModal = () => useContext(ModalContext)

export const InsideModalProvider = ({children}) => (
  <ModalContext.Provider value={true}>{children}</ModalContext.Provider>
)

export default ModalContext
